import { Directive, AfterViewInit } from '@angular/core';
import { IonContent, Platform } from '@ionic/angular';

// We are having a problem on iOS Safari where scrolling down on a ion-content element
// causes the UI to freeze if you swipe down quickly an even number of times. It appears
// that if the ion-content is scrolled all the way to the top, then the body element
// of the page captures the scroll resulting in a few second "hang" until it figures
// out the user isn't trying to scroll the root element. This behavior (and a version
// of this fix) is found at: https://github.com/ionic-team/ionic/issues/13343
//
@Directive({
  selector: '[appScrollBounce]',
  host: {
    '(ionScroll)': 'onScroll($event)',
    '(ionScrollEnd)': 'fixScroll()',  // probably don't need to watch this event any more, but it doesn't hurt
  }
})
export class ScrollBounceDirective implements AfterViewInit {

  shouldFix: boolean = false; 

  constructor(private content: IonContent, private platform: Platform) {
    this.shouldFix = this.platform.is('mobileweb') && this.platform.is('ios')
  }

  ngAfterViewInit() {
    if (this.shouldFix) {
      this.content.scrollEvents = true
      this.fixScroll()  // prescroll on page load

      const t = this
      // Needed on first load and after filtering in case the list is positioned to the top.
      // Figured 1 second (1000 millis) was a good enough time interval.
      navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
        setInterval(() => {
          t.fixScroll()
        }, 1000)
      })
    }
  }

  onScroll(event) {
    // console.log({scroll: event, 'y': event.detail.currentY, 'v': event.detail.velocityY})

    // This only happens when the user drags the list down then releases it
    // and it is springing back up.
    if (event.detail.currentY === 0 && event.detail.velocityY > 0) {
      this.fixScroll()
    }
  }

  fixScroll() {
    if (this.shouldFix) {
      this.content.getScrollElement().then((scrollElement: HTMLElement) => {
        if (scrollElement && scrollElement.scrollTop === 0) {
          scrollElement.scrollTo(0, 1)
        }
      })
    }
  }

}
